import React from 'react';
import './PolitykaRegulamin.css';

const PolitykaRegulamin: React.FC = () => {
  return (
    <section className="pcc-policy-section">
      <div className="pcc-policy-header">
        <h2>Polityka Prywatności i Regulamin</h2>
        <p>Informacje na temat przetwarzania danych osobowych oraz regulamin opisujący zasady, które wszyscy muszą przestrzegać, korzystając z Platformy PCCPORADA.</p>
      </div>

      <div className="pcc-policy-cards-container">
        
        <div className="pcc-policy-card">
          <div className="pcc-icon-wrapper">
            <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
            </svg>
          </div>
          <h3>Regulamin</h3>
          <p>Główny regulamin świadczenia usług drogą elektroniczną przez Platformę PCCPORADA.</p>
          <a href="/pdf/Regulamin_PCCPorada.pdf" target="_blank" rel="noopener noreferrer" className="pcc-btn-outline">
            Pobierz regulamin
          </a>
        </div>

        <div className="pcc-policy-card">
          <div className="pcc-icon-wrapper">
            <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
            </svg>
          </div>
          <h3>Polityka prywatności</h3>
          <p>Zasady przetwarzania danych osobowych oraz wykorzystywania plików cookies w Serwisie.</p>
          <a href="/pdf/PolitykaPrywatnosci_PCCPORADA.pdf" target="_blank" rel="noopener noreferrer" className="pcc-btn-outline">
            Pobierz politykę
          </a>
        </div>

      </div>
    </section>
  );
};

export default PolitykaRegulamin;